import React from "react";

import "./idle.scss";

const IdleIcon = () => {
  const borderClass = "clsIdle-4";

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Status_Idle" transform="translate(12 12)">
        <g id="Group_11730" data-name="Group 11730" transform="translate(-12 -12)">
          <g id="Path_10280" data-name="Path 10280" className="clsIdle-1">
            <path
              className="clsIdle-3"
              d="M 12 22.875 C 6.003499984741211 22.875 1.125 17.99650001525879 1.125 12 C 1.125 6.003499984741211 6.003499984741211 1.125 12 1.125 C 17.99650001525879 1.125 22.875 6.003499984741211 22.875 12 C 22.875 17.99650001525879 17.99650001525879 22.875 12 22.875 Z"
            />
            <path
              className={`${borderClass}`}
              d="M 12 2.25 C 6.623830795288086 2.25 2.25 6.623830795288086 2.25 12 C 2.25 17.37617111206055 6.623830795288086 21.75 12 21.75 C 17.37617111206055 21.75 21.75 17.37617111206055 21.75 12 C 21.75 6.623830795288086 17.37617111206055 2.25 12 2.25 M 12 0 C 18.62699890136719 0 24 5.37299919128418 24 12 C 24 18.62699890136719 18.62699890136719 24 12 24 C 5.37299919128418 24 0 18.62699890136719 0 12 C 0 5.37299919128418 5.37299919128418 0 12 0 Z"
            />
          </g>
          <rect id="Rectangle_1086" data-name="Rectangle 1086" className="clsIdle-2" width="9" height="2.25" transform="translate(7.5 10.875)" />
        </g>
      </g>
    </svg>
  );
};

export default IdleIcon;
